import { useControllerAppModel } from '@/controller/models/ControllerAppModel';
import { Card, Dialog } from '@toilet-paper-games/ui';
import { observer } from 'mobx-react-lite';

export const KickedDialog = observer(() => {
  const appModel = useControllerAppModel();

  return (
    <Dialog open={appModel.wasKicked}>
      <Card>
        <p>You have been disconnected</p>
        <p>Reload the page to rejoin</p>
      </Card>
    </Dialog>
  );
});
